import { getApiClient } from '@offertify/api-client';

export interface Catalogo {
  id: string;
  marca: string;
  titolo: string;
  tipo: 'file' | 'link';
  url?: string | null;
  filename?: string | null;
  content_type?: string | null;
  file_size_bytes?: number | null;
}
export interface CatalogoData { marca: string; titolo: string; url?: string }
const http = () => getApiClient().client;
export const cataloghiAPI = {
  list: (params: { page: number; marca?: string; search?: string }) => http().get<{ data: Catalogo[]; pagination: { total: number; pages: number } }>('/cataloghi', { params }),
  brands: () => http().get<string[]>('/cataloghi/marche'),
  createLink: (data: CatalogoData) => http().post<Catalogo>('/cataloghi/links', data),
  upload: (data: CatalogoData, file: File) => {
    const form = new FormData(); form.append('marca', data.marca); form.append('titolo', data.titolo); form.append('file', file);
    return http().post<Catalogo>('/cataloghi/upload', form, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  update: (id: string, data: CatalogoData) => http().put<Catalogo>(`/cataloghi/${id}`, data),
  delete: (id: string) => http().delete(`/cataloghi/${id}`),
  url: (id: string, download = false) => http().get<{ url: string }>(`/cataloghi/${id}/url`, { params: { download } }),
};
